/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_No_ResultsInputs */



/**
* | output |
* | --- |
* | "No players found with 5+ wins" |
*
* @param {Hof_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const hof_no_results = /** @type {((inputs?: Hof_No_ResultsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_No_ResultsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun joueur trouvé correspondant à vos critères.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron jugadores que cumplan sus criterios.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum jogador encontrado que corresponda aos seus critérios.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun giocatore trovato che corrisponda ai tuoi criteri.")
	return /** @type {LocalizedString} */ ("No players found with 5+ wins")
});